import {KazBlurImageComponent} from '../kaz-blur-image/kaz-blur-image.component';
import {Component, Input, OnInit, ChangeDetectionStrategy} from '@angular/core';
import {Ad, PriceType} from "../../interfaces/ad";
import {getDummyPicture} from "../../utils/dummyImages";
import { RouterLink } from '@angular/router';
import { CurrencyPipe } from '@angular/common';
import { ImageSourcePipe } from '../../pipes/image-source.pipe';

@Component({
    selector: 'kaz-card-recommended',
    templateUrl: './kaz-card-recommended.component.html',
    styleUrls: ['./kaz-card-recommended.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [KazBlurImageComponent, RouterLink, CurrencyPipe, ImageSourcePipe]
})
export class KazCardRecommendedComponent implements OnInit {
  @Input() ad: Ad | null = null;

  constructor() {
  }

  async ngOnInit() {
  }

  protected readonly getDummyPicture = getDummyPicture;
    protected readonly PriceType = PriceType;
}
